<!-- eslint-disable -->
<template>
  <div :class="['col-md-8 col-lg-8 offset-md-2 offset-lg-2 page eh-ds', { 'page--mobile': isMobile() }]">
    <div class="page-help-corner">
      <help-icon help-id="cpt" title="Help for CPT" />
    </div>
    <div class="cpt__list">
      <h1 :class="['list__header mt-md-0 mt-0', { 'list__header--mobile': isMobile() }]">CPT ASSIGNMENTS</h1>

      <template v-if="!isMobile()">
        <div class="gridarea">
          <div class="container">
            <div class="columntop">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col1" class="coltext">Code</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col2" class="coltext">Description</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col3" class="coltext">Frequency</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col4" class="coltext">Meter(s)</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col5" class="coltext">Current Cycle Start</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col6" class="coltext">Current Cycle End</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col7" class="coltext">Current Cycle Count</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col8" class="coltext">Status</span>
              </div>
            </div>
            <template v-for="(cpt, key, index) in cptInfo">
              <div
                class="columnrow"
                data-bs-toggle="collapse"
                :href="'#cptInfo' + key"
                aria-expanded="false"
                :aria-controls="'cptInfo' + key"
                role="button"
              >
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cptCode" class="coltext">{{ key }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device">
                  <span id="cptDesc" class="coltext">{{ cpt.desc }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cptFreq" class="coltext">{{ cpt.timeframe }}</span>
                </div>
                <div
                  class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device meterListColumn"
                >
                  <div v-if="currentMeters.length != 0" class="meterList">
                    <span
                      v-for="meter in assignedMeters[key]"
                      :id="'meterList' + meter['0'] + meter['1']"
                      :key="'test' + meter['0'] + meter['1']"
                      class="coltext"
                    >
                      {{ meter.meter + (meter.meterName ? ` (${meter.meterName})` : "") }}
                    </span>
                  </div>
                  <span id="meterOptions" class="coltext">
                    <select
                      @change.stop="addingNewMeter(key)"
                      v-model="addedMeter[key]"
                      :id="'addedMeter' + key + index"
                    >
                      <option selected :value="0">Add Meter</option>
                      <option
                        v-for="meter in availableMeters(key)"
                        :key="meter.MeterID._text + 'cpt' + key"
                        :value="meter"
                      >
                        {{ meter.MeterID._text + " (" + meter.MeterName._cdata + ")" }}
                      </option>
                    </select>
                  </span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleStart" class="coltext">{{
                    currentData[key] ? currentData[key].firstDate : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleEnd" class="coltext">{{
                    currentData[key] ? currentData[key].lastDate : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleCount" class="coltext">{{
                    currentData[key]
                      ? formatCycleCount(key, currentData[key].cycleCount)
                      : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cycleStatus" class="coltext">{{
                    cycleStatusLabel(key)
                  }}</span>
                </div>
              </div>
              <div class="collapse cpt-expand" :id="'cptInfo' + key">
                <div class="cpt-expand__body">
                  <cpt-desc
                    :cpt="key"
                    :currentInfo="currentData[key]"
                    :historicalInfo="getHistoricalData(key)"
                    :measurements="getCptMeas(key)"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="table-container">
          <div class="accordion">
            <div
              v-for="(cpt, key, index) in cptInfo"
              :key="key"
              :id="'cpt' + key"
              class="accordion-item"
            >
              <button type="button" class="accordion-button" @click="showCpt(key)">
                {{ key }} — {{ cpt.desc }}
              </button>
              <div class="accordion-content" @click.stop>
                <p><b>Frequency:</b> {{ cpt.timeframe }}</p>
                <div class="cpt-mobile-meters">
                  <p><b>Meter(s):</b></p>
                  <ul v-if="assignedMeters[key].length" class="cpt-mobile-meter-list">
                    <li
                      v-for="meter in assignedMeters[key]"
                      :key="'mobile-meter-' + key + meter.meter"
                    >
                      {{ meter.meter + (meter.meterName ? ` (${meter.meterName})` : "") }}
                    </li>
                  </ul>
                  <p v-else class="cpt-mobile-empty">No meters assigned</p>
                  <select
                    v-if="currentMeters.length"
                    class="cpt-mobile-select"
                    @change="addingNewMeter(key)"
                    v-model="addedMeter[key]"
                    :id="'addedMeterMobile' + key + index"
                  >
                    <option selected :value="0">Add Meter</option>
                    <option
                      v-for="meter in availableMeters(key)"
                      :key="meter.MeterID._text + 'cpt-mobile' + key"
                      :value="meter"
                    >
                      {{ meter.MeterID._text + " (" + meter.MeterName._cdata + ")" }}
                    </option>
                  </select>
                </div>
                <p><b>Cycle Start:</b> {{ currentData[key] ? currentData[key].firstDate : "N/A" }}</p>
                <p><b>Cycle End:</b> {{ currentData[key] ? currentData[key].lastDate : "N/A" }}</p>
                <p>
                  <b>Cycle Count:</b>
                  {{
                    currentData[key]
                      ? formatCycleCount(key, currentData[key].cycleCount)
                      : "N/A"
                  }}
                </p>
                <p><b>Status:</b> {{ cycleStatusLabel(key) }}</p>
                <div class="cpt-mobile-detail">
                  <cpt-desc
                    :cpt="key"
                    :currentInfo="currentData[key]"
                    :historicalInfo="getHistoricalData(key)"
                    :measurements="getCptMeas(key)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import cptInfo from "@/data/cptInfo";
import { xml2js } from "xml-js";
import CptDesc from "../private-layouts/CptDesc.vue";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import HelpIcon from "@/components/help/HelpIcon.vue";

export default {
  name: "CptPage",
  components: {
    "cpt-desc": CptDesc,
    HelpIcon,
  },
  data() {
    return {
      cptInfo,
      addedMeter: {
        99453: 0,
        99454: 0,
        99457: 0,
        99458: 0,
        98975: 0,
        98976: 0,
        98980: 0,
        98981: 0,
        99091: 0,
      },
      currentMeters: [],
      assignedMeters: {
        99453: [],
        99454: [],
        99457: [],
        99458: [],
        98975: [],
        98976: [],
        98980: [],
        98981: [],
        99091: [],
      },
      currentData: {},
      historicalData: {},
      measurements: [],
    };
  },
  mounted() {
    // Check db if cptCodes exists for patient, if not then make one
    this.getDevices();
    this.getAddedMeters();
    this.getCptData();
    this.getMeasurements();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showCpt(key) {
      const entry = document.getElementById(`cpt${key}`);
      if (entry) {
        entry.classList.toggle("active");
      }
    },
    cycleStatusLabel(key) {
      if (!this.currentData[key]) {
        return "N/A";
      }
      return { 0: "Not Billable", 1: "Billable", 2: "Billed" }[this.currentData[key].status];
    },
    fmtMSS(s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
    formatCycleCount(cpt, count) {
      let append = " unique daily recordings";
      if (cpt === "98980" || cpt === "98981" || cpt === "99457" || cpt === "99458") {
        append = " minutes";
        return `${this.fmtMSS(count)} ${append}`;
      }
      return `${count} ${append}`;
    },
    async getMeasurements() {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeasurements2",
          pid:
            ("" + this.allData.patient.externId).length == 7
              ? "0" + this.allData.patient.externId
              : "" + this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.measurements = res.data.data;
        });
    },
    getCptMeas(cpt) {
      if (this.measurements.length != 0) {
        let meters = this.assignedMeters[cpt].map((m) => m.meter);
        let answer = this.measurements.filter((meas) => meters.includes(meas.MDeviceID));
        return answer;
      }
      return [];
    },
    getHistoricalData(key) {
      let data = this.historicalData[key];
      if (data) {
        let current = this.currentData[key];
        data[current.fid] = current;
      }
      return data;
    },
    async getCptData() {
      let content = {
        PatientCpt: {
          API_Meth: "GetPatientCpt2",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.currentData = res.data.current;
          this.historicalData = res.data.historical;
        });
    },
    availableMeters(key) {
      let result = [];
      let meterNames = this.assignedMeters[key].map((meter) => meter.meter);
      this.currentMeters.forEach((meter) => {
        if (!meterNames.includes(meter.MeterID._text)) {
          result.push(meter);
        }
      });
      return result;
    },
    async getAddedMeters() {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeterCpt",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Success" && res.data.count != 0) {
            let results = res.data.result;
            results.forEach((m) => {
              this.assignedMeters[m.cpt].push(m);
            });
          } else if (res.data.status != "Success") {
            alert(res.data.status);
          }
        });
    },
    async addingNewMeter(key) {
      let meterInfo = this.addedMeter[key];
      if (meterInfo == 0) return;
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.METER_CPT_ASSIGNMENTS_ADD,
          "You do not have permission to add meter CPT assignments."
        )
      ) {
        this.addedMeter[key] = 0;
        return;
      }
      let key2 =
        key === "98980"
          ? "98981"
          : key === "98981"
          ? "98980"
          : key === "99457"
          ? "99458"
          : key === "99458"
          ? "99457"
          : "";
      let confirmMsg = "";
      if (key2 === "")
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT code ${key}?`;
      else
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT codes ${key} and ${key2}?`;

      if (confirm(confirmMsg)) {
        let content = {
          PatientCpt: {
            API_Meth: "AddMeterCpt",
            pid: this.allData.patient.externId,
            meter: meterInfo.MeterID._text,
            cpt: key,
            meterName: meterInfo.MeterName._cdata,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.status == "Success") {
              if (key2 != "") {
                content["PatientCpt"]["cpt"] = key2;
                axios
                  .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                  })
                  .then((res) => {
                    if (res.data.status == "Success") {
                      for (var el in this.assignedMeters) this.assignedMeters[el] = [];
                      this.getAddedMeters();
                    } else {
                      alert(res.data.status);
                    }
                  });
              } else {
                for (var el in this.assignedMeters) this.assignedMeters[el] = [];
                this.getAddedMeters();
              }
            } else {
              alert(res.data.status);
            }
          });
      }
      this.addedMeter[key] = 0;
    },
    async getDevices() {
      let content = {
        GetPatientInfo: {
          API_Meth: "GetPatientDevice",
          pid:
            ("" + this.allData.patient.externId).length == 7
              ? "0" + this.allData.patient.externId
              : "" + this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(
          (res) => {
            let xml = res.data.ReMsg;
            if (!xml) return;
            let json = xml2js(xml, { compact: true });
            let meters = json["QueryResult"]["ReData"]
              ? json["QueryResult"]["ReData"]["CaseMeterData"]["Meter"]
              : [];
            if (Array.isArray(meters)) {
              this.currentMeters = meters;
            } else if (typeof meters === "object") {
              this.currentMeters = [meters];
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}

.page-help-corner {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.35rem;
}

.page--mobile {
  margin: 0.75rem auto;
  padding: 1rem;
  margin-bottom: 80px;
}

.row {
  flex-wrap: nowrap;
}

.device__header,
.list__header {
  font-size: 2.5rem;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.list__header--mobile {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.columntop {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.7fr 2.4fr 0.85fr 1.45fr 1fr 1fr 1.15fr 0.75fr;
  align-items: center;
}

.columnrow {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.7fr 2.4fr 0.85fr 1.45fr 1fr 1fr 1.15fr 0.75fr;
  align-items: start;
}

.cpt__list .gridarea {
  overflow-x: auto;
}

.cpt__list .gridarea .container {
  width: 100%;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}

.cpt__list .columntop > *,
.cpt__list .columnrow > * {
  flex: none;
  max-width: none;
  width: auto;
  min-width: 0;
  padding: 0.7rem 0.55rem;
  text-align: left;
}

.cpt__list .columnrow {
  border-bottom: 1px solid #d3d7db;
}

.cpt__list #cptDesc {
  line-height: 1.4;
  display: block;
}

.cpt-expand {
  width: 100%;
}

.cpt-expand__body {
  width: 100%;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
}

.columnbottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
}

.pagnav a {
  margin-left: 10px;
}

.searchfindarea .container {
  display: flex;
  flex-direction: row;
}

.gridarea {
  width: 100%;
  height: auto;
}

.top-row-device {
  border-right: 1px solid #d3d7db;
}

.top-row-device:last-child {
  border-right: none;
}

.meterList {
  display: flex;
  flex-direction: column;
}

.meterListColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#meterOptions {
  margin-bottom: 5%;
}

.table-container {
  padding: 0;
}

.accordion {
  margin-top: 0;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button,
button.accordion-button {
  padding: 12px 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 0.95rem;
  line-height: 1.35;
  word-break: break-word;
}

.accordion-content {
  display: none;
  padding: 15px;
}

.accordion-item.active .accordion-content {
  display: block;
}

.accordion-content p {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  word-break: break-word;
}

.cpt-mobile-meters {
  margin-bottom: 0.75rem;
}

.cpt-mobile-meter-list {
  list-style: none;
  padding-left: 0;
  margin: 0 0 0.5rem;

  li {
    font-size: 0.95rem;
    padding: 0.15rem 0;
    word-break: break-word;
  }
}

.cpt-mobile-empty {
  font-size: 0.9rem;
  margin-bottom: 0.5rem !important;
}

.cpt-mobile-select {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #d3d7db;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 0.25rem;
}

.cpt-mobile-detail {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #d3d7db;
}
</style>
